let resolveRoutingReady: (() => void) | null = null;
let isRoutingReady = false;

export const routingReady = new Promise<void>(resolve => {
  resolveRoutingReady = () => {
    if (!isRoutingReady) {
      isRoutingReady = true;
      resolve();
    }
  };
});

export const markRoutingReady = (): void => {
  if (resolveRoutingReady) {
    resolveRoutingReady();
    resolveRoutingReady = null;
  }
};
